import colors from "tailwindcss/colors"
export default function useTailwindColor(color: string): string{
    const colorArr = color.split('-')
    return colors[colorArr[0]][colorArr[1]]
}